<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONTRATOS - REGISTROS DE PAGAMENTOS</span>
                    <div class="float-right">
                        <span class="text-primary">
                            <i
                                class="fa fa-refresh fa-lg icon-button"
                                title="Atualizar"
                                @click.stop="$emit('atualizar-listagem')"
                            ></i>
                        </span>
                    </div>
                </h4>
                <slot name="controles"></slot>
                <totais-status :totaisStatus="totaisStatus"></totais-status>
                <app-tabela
                    idTabela="tblPagamentos"
                    :itens="pagamentos"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <b-button-group class="ml-2 float-right">
                            <b-button
                                variant="primary"
                                @click="toSolicitacoes()"
                                v-if="$temAcessoView('CONT-PAG-05')"
                            >
                                Solicitações de Autorização para Envio Fora do
                                Prazo</b-button
                            >
                        </b-button-group>
                        <pagamento-inserir
                            :pagamentosServicos="pagamentosServicos"
                            @detalharPagamento="
                                $emit('detalhar-pagamento', $event)
                            "
                        ></pagamento-inserir>
                        <slot name="botoes"></slot>
                    </template>
                    <template slot="protocolo" slot-scope="data">
                        {{ data.protocolo }}
                        <span v-if="data.prioritario"
                            ><br /><app-status status="PRIORITÁRIO"></app-status
                        ></span>
                        <span v-if="data.especial"
                            ><br />
                            <app-status status="ESPECIAL"></app-status>
                        </span>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <slot name="acoes" v-bind="data"></slot>
                    </template>
                    <template slot="valorTotal" slot-scope="data">{{
                        data.valorTotal | currency
                    }}</template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import PagamentoInserir from './PagamentoInserir'
import TotaisStatus from './TotaisStatus'

export default {
    props: {
        titulo: {
            type: String,
            default: () => 'PAGAMENTOS'
        },

        pagamentos: {
            type: Array,
            default: () => []
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        },

        showFornecedor: {
            type: Boolean,
            default: true
        },

        totaisStatus: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'protocolo',
                    label: 'Protocolo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'fornecedor',
                    label: 'Fornecedor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'contrato',
                    label: 'Contrato',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'qtdComprometimentos',
                    label: 'Qtd Serviços',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'processos',
                    label: 'Processos',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'comprometimentos',
                    label: 'IDs RM',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'qtdAnexos',
                    label: 'Anexos',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'documentos',
                    label: 'Documentos',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                }
            ],
            itensPorPagina: 0
        }
    },
    methods: {
        toSolicitacoes() {
            this.$router.push({ name: 'Contratos_Pagamentos_Solicitacoes' })
        }
    },

    created() {
        if (!this.showFornecedor) {
            this.campos.splice(2, 1)
        }
    },

    computed: {},

    watch: {},

    components: {
        PagamentoInserir,
        TotaisStatus
    }
}
</script>
